import React, { Children, memo } from "react";
import { Box, Divider, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { theme } from "../../../utils";
import eyeImage from '../../../assets/images/other/eye.png'
import TranslationMsg from "./transMessage";

type MailtoLinkProps = {
    email?: string | null;
    children?: React.ReactNode;
};

const MailtoLink: React.FC<MailtoLinkProps> = ({ email, children }) => {
    if (!email?.trim()) return null;

    return (
        <a href={`mailto:${email}`} style={{ fontWeight: "700", color: "#1E1E22", textDecoration: "none" }}>
            {children ?? email}
        </a>
    );
};

const styles = {
    secondaryCard: {
        p: "19px 27px 19px 36px",
        backgroundColor: "#F8F8F8",
        borderRadius: "1rem",
        minWidth: "290px"
    },
    compatibilityCard: {
        maxWidth: "297px",
        maxHeight: "225px",
        alignSelf: "flex-start",
        height: "auto"
    },
    contactUsCard: {
        marginTop: "18px",
        maxWidth: "297px",
        maxHeight: "225px",
        alignSelf: "flex-start",
        height: "auto"
    }
}

interface IVendorFeaturesProps {
    featureData?: any
}
const VendorFeatures = (props: IVendorFeaturesProps) => {
    const { featureData } = props
    const { t } = useTranslation();
    const compatibilityList = Array.isArray(featureData?.compatibility?.list) ? featureData?.compatibility?.list?.join(" | ") : ""

    return (
        <>
            <Box display={"flex"} flexWrap={"wrap"} gap={'1rem'} mt={"40px"} mb={"40px"}>
               <Box>
                {featureData?.compatibility?.title || compatibilityList ?
                    <Box sx={[styles.secondaryCard, styles.compatibilityCard]}>
                        <Typography sx={{ ...theme.typography.opticianBodyRegular, mb: '12px', textTransform: "uppercase" }}>{t(TranslationMsg.COMPATIBILITY_LABEL)}</Typography>
                        <Box>
                            <Typography sx={{ ...theme.typography.poppinsBodyLight, fontSize:'20px' }}>{featureData?.compatibility?.title}</Typography>
                            <img src={eyeImage} style={{ width: "44px", height: "44px" }} alt="compatibility-logo" />
                            <Typography sx={{ ...theme.typography.poppinsBodySemiBold, fontSize:'14px', maxWidth: "234px" }}>{compatibilityList}</Typography>
                        </Box>
                    </Box> : null}

                   <Box sx={{...styles.secondaryCard, ...styles.contactUsCard, backgroundColor: featureData?.contactUs?.backgroundColor }}>
                        <Typography sx={{ ...theme.typography.opticianBodyRegular, textTransform: "uppercase" }}>{t(TranslationMsg.CONTACT_US_LABEL)}</Typography>
                       <Box mt={"20px"}>
                           <Typography sx={{ ...theme.typography.poppinsBodyLight, fontWeight: 400, fontSize:"regular", color: "#1E1E22", lineHeight:"110%", letterSpacing:"0px"}}>
                               Reach us at <MailtoLink email={featureData?.contactUs?.emailAddress} /> with any questions.
                           </Typography>

                       </Box>
                    </Box>
                </Box>

                {featureData?.features?.length > 0 ?
                    <Box sx={styles.secondaryCard} flex={1}>
                        <Typography sx={{ ...theme.typography.opticianBodyRegular, textTransform: "uppercase" }}>{t(TranslationMsg.KEY_FEATURES_LABEL)}</Typography>
                        <ul style={{ paddingLeft: "22px", paddingBottom: "0px" }}>
                            {Children.toArray(featureData?.features.map((item: any, index: number) => (
                                <li key={index + 1}>
                                    <Typography sx={{ ...theme.typography.poppinsBodyBold, fontSize:'16px' }}>
                                    {`${item?.title ?? ""}:`}
                                        <span style={{ ...theme.typography.poppinsBodyRegular, fontSize:'16px' }}>{` ${item?.description ?? ""}`}</span>
                                    </Typography>
                                </li>
                            )))}
                        </ul>
                    </Box> : null}
            </Box>
            {featureData?.features?.length > 0 ?
                <Divider />
                : null
            }
        </>
    )
}

export default memo(VendorFeatures)